import React, { useEffect, useState } from "react";
import Filter from "../../../components/ui/Filter";
import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import {
  useAddMealsMutation,
  useUpdateMealsMutation,
} from "../../../featureSlice/mealSliceApi";
import DateTimePicker from "../../../components/ui/date-filter/DateTimePicker";
import { format } from "date-fns";

const MealFilter = ({ close, editData = null }) => {
  const [formData, setFormData] = useState({
    meal_name: "",
    shift: "",
     start_time: null,   
    end_time: null,
    description: "",
  });

  const [addMeal] = useAddMealsMutation();
  const [updateMeal] = useUpdateMealsMutation();

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (editData) {
      setFormData({
        meal_name: editData?.meal_name || "",
        shift: editData?.shift || "",
        start_time: editData?.start_time
          ? new Date(`1970-01-01T${editData.start_time}`)
          : null,
        end_time: editData?.end_time
          ? new Date(`1970-01-01T${editData.end_time}`)
          : null,
        description: editData?.description || "",
      });
    }
  }, [editData]);

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
         start_time: formData.start_time
          ? format(formData.start_time, "HH:mm") 
          : "",
        end_time: formData.end_time
          ? format(formData.end_time, "HH:mm")   
          : "",
      };

      if (editData) {
        await updateMeal({ id: editData?.id, ...payload }).unwrap();
      } else {
        await addMeal(payload).unwrap();
      }
      close();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleCancel = () => {
    setFormData({
      meal_name: "",
      shift: "",
      start_time: null,
      end_time: null,
      description: "",
    });
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow space-y-4 absolute top-52 mt-4 right-7 w-96 text-darkGray font-medium">
      <Button
        className="float-end text-xl cursor-pointer bg-white hover:bg-transparent border-none "
        onClick={close}
      >
        X
      </Button>

      <Filter
        type="input"
        label="Meal Name"
        name="meal_name"
        value={formData?.meal_name}
        onChange={handleChange}
      />

      <Filter
        type="select"
        label="Shift"
        name="shift"
        value={formData?.shift}
        onChange={handleChange}
        options={[
          { label: "Shift A", value: "Shift A" },
          { label: "Shift B", value: "Shift B" },
          { label: "Shift C", value: "Shift C" },
        ]}
      />

      <div className="flex flex-col">
        <Label>Start Time</Label>
        <DateTimePicker
          type="time"
         value={formData.start_time}
          onChange={(val) => handleChange("start_time", val)}
        />
      </div>

      <div className="flex flex-col">
        <Label>End Time</Label>
        <DateTimePicker
          type="time"
          value={formData.end_time}
          onChange={(val) => handleChange("end_time", val)}
        />
      </div>

      <Filter
        type="input"
        label="Description (Optional)"
        name="description"
        value={formData?.description}
        onChange={handleChange}
      />

      <div className="flex justify-between gap-4 pt-4">
        <Button variant="outline" onClick={handleCancel} className="px-8">
          Cancel
        </Button>
        <Button onClick={handleSubmit} className="bg-primary text-white px-8">
          Submit
        </Button>
      </div>
    </div>
  );
};

export default MealFilter;
